<template>
    <div class="venueInfo_main">
        <div class="backBox" @click="back">
            <i class="el-icon-back myback_icon"></i> Back
        </div>
        <section class="venue_top">
            <div class="venueInfo_item">
                <div class="infoLabel-box">ID</div>
                <div class="infoValue-box">6G1qwAog</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Venue Name</div>
                <div class="infoValue-box">PEISO Test Venue</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Vendor</div>
                <div class="infoValue-box">PEISO POS-1</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Address</div>
                <div class="infoValue-box">30 Hay Street Donvale VIC 3000</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Latitude</div>
                <div class="infoValue-box">0</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Longitude</div>
                <div class="infoValue-box">0</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Phone Number</div>
                <div class="infoValue-box">Null</div>
            </div>
        </section>
        <section class="venue_top venue_middie">
            <div class="venueInfo_item">
                <div class="infoLabel-box">Health Check</div>
                <div class="infoValue-box">supported</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Order Pre Process</div>
                <div class="infoValue-box">supported</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Auto Complete Checkin</div>
                <div class="infoValue-box">unsupported</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Mapped LocationId</div>
                <div class="infoValue-box">12345</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">OrganisationId</div>
                <div class="infoValue-box">Epj79QkB</div>
            </div>
        </section>
        <section class="venue_top">
            <div class="venueInfo_item">
                <div class="infoLabel-box">Updated At</div>
                <div class="infoValue-box">2021-12-15T07:32:03.337Z</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">Created At</div>
                <div class="infoValue-box">2021-07-23T08:22:43.972Z</div>
            </div>
            <div class="venueInfo_item">
                <div class="infoLabel-box">URL</div>
                <div class="infoValue-box">https://sandbox.doshii.co/partner/v3/locations/6G1qwAog</div>
            </div>
        </section>
        <section class="venue_middie timeList-box">
            <div class="title">Opening Hours</div>
            <el-table
			:data="tableData"
			class="roster_table time-table"
			style="width: 100%">
				<el-table-column
				prop="week"
				align="left"
                width="150"
				label-class-name="roster_th"
				class-name="roster_row"
				label="WEEK">
				</el-table-column>
				<el-table-column
				prop="time"
				align="center"
				label-class-name="roster_th time_th"
				class-name="time_row"
				label="TIME">
				</el-table-column>
			</el-table>
        </section>
        <footer>
            <button class="footer_btn w150">Remove</button>
            <button class="footer_btn w280 margin-auto" @click="connectVenue">Connect Peiso Venue</button>
            <button class="footer_btn w280" @click="create">Create New Venue</button>
        </footer>
    </div>
</template>

<script>
import api from '../../api/dishi'
export default {
    data() {
        return {
            tableData:[
                {week:'Monday',time:'Closed'},
                {week:'Tuesday',time:'Closed'},
                {week:'Wednesday',time:'Closed'},
                {week:'Thursday',time:'Closed'},
                {week:'Friday',time:'Closed'},
                {week:'Saturday',time:'Closed'},
                {week:'Sunday',time:'Closed'}
            ],
            info:{
                id:'',
                venueName:'',
                vendor:'',
                address:'',
                Latitude:'',
                Latitude:'',
                phone:'',
                HealthCheck:'',
                OrderPreProcess:'',
                AutoCompleteCheckin:'',
                MappedLocationId:'',
                OrganisationId:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
                id:'',
            }
        }
    },
    methods: {
        getDoshi(){
            const id = window.sessionStorage.getItem('doshiId')
            api.getDoshiDetail({id:id},res=>{
                let {code,data,message}=res.data;
                if(code==0){

                }else{
                    Utils.alert('',message,'error')
                }
            })
        },
        back(){
            this.$router.go(-1)
        },
        connectVenue(){
            this.$router.push('/connet-venue')
        },
        create(){
            this.$router.push('/create-venue')
        }
    },
}
</script>

<style lang='scss' scoped>
.venueInfo_main{
    .backBox{
        display: flex;
        height: 16px;
        font-size: 14px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 16px;
        margin-bottom: 56px;
        width: 100px;
        cursor: pointer;
    }
    .venue_top{
        width: 100%;
        background: #2B3444;
        padding: 50px 30px;
        display: flex;
        flex-wrap: wrap;
        .venueInfo_item{
            min-width: 50%;
            flex: 1;
            color: #FFFFFF;
            padding-bottom: 30px;
            &:last-child{
                padding: 0;
            }
            .infoLabel-box{
                height: 16px;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 16px;
            }
            .infoValue-box{
                margin-top: 10px;
                height: 28px;
                font-size: 20px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 28px;
            }
        }
    }
    .venue_middie{
        margin: 30px 0;
    }
    .timeList-box{
        width: 100%;
        background: #2B3444;
        padding: 50px 30px;
        margin-bottom: 110px;
        .title{
            height: 16px;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 16px;
            margin-bottom: 10px;
        }
    }
    footer{
        position: fixed;
        bottom: 0px;
        width: calc(100% - 160px);
        height: 80px;
        background: #2B3444;
        box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        padding-right: 30px;
        .footer_btn{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 40px;
            background: #2B3444;
            border: 2px solid #FFFFFF;
            color: #FFFFFF;
            font-size: 18px;
            font-weight: 600;
            cursor: pointer;
        }
        .w150{
            width: 150px;
        }
        .w280{
            width: 280px;
            color: #EA3796;
            border: 2px solid #EA3796;
        }
        .margin-auto{
            margin: 0 30px 0 auto;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/doshi/venueInfo.vue